<template>
  <div class="created-form-content">
    <div class="form-model" v-if="isDisabled"></div>
    <el-form ref="generateForm"
             label-suffix=":"
             :size="data.config.size"
             :model="models" :label-position="data.config.labelPosition" :label-width="`${data.config.labelWidth}px`">
      <template v-for="item in data.list">
        <template v-if="item.type == 'grid'">
          <el-row
            :key="item.key"
            type="flex"
            :gutter="item.options.gutter ? item.options.gutter : 0"
            :justify="item.options.justify"
            :align="item.options.align"
          >
            <el-col v-for="(col, colIndex) in item.columns" :key="colIndex" :span="col.span">
              <template v-for="citem in col.list">
                <template v-if="citem.type=='blank'">
                  <slot v-if="citem.options.isTitle==false" :name="citem.model" :model="models"></slot>
                  <el-form-item v-else :label="citem.name" :prop="citem.model" :key="citem.key"
                                :class="citem.options.otherClass">
                    <slot :name="citem.model" :model="models"></slot>
                  </el-form-item>
                </template>

                <CreatedFormItem v-else
                                 :key="citem.key"
                                 :models.sync="models"
                                 :remote="remote"
                                 :rules="rules"
                                 :islable="true"
                                 :disableArr="disableArr"
                                 :funModel="funModel"
                                 :formData="citem"
                                 @changeData="changeDateFun">
                </CreatedFormItem>
              </template>
            </el-col>
          </el-row>
        </template>
        <template v-else-if="item.type==='table'">
          <div :key="item.key">
            <div style="margin: 20px 0px">

              <el-button @click="addSubitem(item)" v-if="item.options.btnadd">新增</el-button>

            </div>
            <template v-if="models[item.model].length>0&&maxScrollLeft>0">
              <el-button @click="leftEvent" icon="el-icon-caret-left"></el-button>
              <el-button @click="rightEvent" icon="el-icon-caret-right"></el-button>
            </template>
            <el-table
              ref="editTable"
              :key="item.key"
              :data="models[item.model]"
              class="subtable"
              :height="item.options.tableHeight"
              :row-class-name="tableRowClassName"
              border fit :show-summary="tableTotalArray.map(m=>m.tablemodel).includes(item.model)"
              :summary-method="function(param){return getSummaries(param,item.model)} "
            >
              <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
              <template v-for="(tableItem) in item.list">
                <el-table-column :fixed="tableItem.options.isFix" :key="tableItem.key" :label="tableItem.name"
                                 :prop="tableItem.model"
                                 align="center"
                                 :width="tableItem.options.tableWidth">
                  <template slot-scope="scope">
                    <CreatedFormItem
                      :key="tableItem.key"
                      :models.sync="scope.row"
                      :rules="lstDtlrules"
                      :formData="tableItem"
                      :itemkey="scope.$index"
                      :tablemodel="item.model"
                      :disableArr="disableArr"
                      :remote="tableItem.remote"
                      :funModel="funModel"
                      :islable="false"
                      @changeData="changeDateFun"
                    >
                    </CreatedFormItem>
                  </template>
                </el-table-column>
              </template>
              <el-table-column min-width="60px" fixed="right" align="center" label="操作" v-if="item.options.btndel">
                <template slot-scope="scope">
                  <!-- <span>
                    <i class="el-tag el-tag--danger el-tag--mini" style="cursor: pointer;" @click.prevent="removeSubitem(scope.row,item.model)">删除</i>
                  </span> -->
                  <el-button type="text" size="small" @click.prevent="removeSubitem(scope.row,item.model)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
        <template v-else-if="item.type == 'blank'">
          <!-- <el-form-item :label="item.name" :prop="item.model" :key="item.key">
            <slot :name="item.model" :model="models"></slot>
          </el-form-item> -->
          <slot v-if="item.options.isTitle==false" :name="item.model" :model="models"></slot>
          <el-form-item v-else :label="item.name" :prop="item.model" :key="item.key">
            <slot :name="item.model" :model="models"></slot>
          </el-form-item>
        </template>
        <template v-else>
          <CreatedFormItem
            :key="item.key"
            :models.sync="models"
            :rules="rules"
            :formData="item"
            :islable="true"
            :funModel="funModel"
            :disableArr="disableArr"
            :remote="remote"
            @changeData="changeDateFun">
          </CreatedFormItem>
        </template>
      </template>
    </el-form>
  </div>
</template>

<script>
import CreatedFormItem from './CreatedFormItem';

export default {
  name: 'fm-generate-form',
  components: {
    CreatedFormItem
  },
  props: ['data', 'remote', 'value', 'insite', 'isDisabled', 'funModel', 'tableDeleteFun', 'errDetailGuidArray', 'isFix'],
  data() {
    return {
      tableTotalArray: [],
      fuMalkeyArray: [],
      models: {},
      rules: {},
      disableArr: [],
      lstDtlrules: {}, // 处理主表和子表字段同名冲突
      restTabel: [], // 重置table数据时使用的数组
      maxScrollLeft: 0 // 最大左滑距离
    };
  },
  created() {
    this.generateModle(this.data.list);
    Object.keys(this.value).forEach(item => {
      this.$set(this.models, item, this.value[item]);
    });
  },
  mounted() {
    if (this.$refs.editTable && this.$refs.editTable.length > 0) {
      this.maxScrollLeft = Number(this.$refs.editTable[0].bodyWidth.replace('px', '')) - this.$refs.editTable[0].$el.clientWidth;
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      const array = [];
      console.log(this.errDetailGuidArray);
      if (this.errDetailGuidArray && this.errDetailGuidArray.length > 0) {
        this.value.orderDetail.forEach((item1, index1) => {
          const a = this.errDetailGuidArray.find((item2) => {
            return item2 === item1.id;
          });
          if (a > -1) {
            array.push(index1);
          }
        });
      }
      console.log('array', array);
      if (array.includes(rowIndex)) {
        return 'warning';
      } else {
        return '';
      }
    },
    leftEvent() {
      // console.log(this.$refs.editTable[0].$el.clientWidth);
      // console.log('###', this.$refs.editTable[0].bodyWrapper.scrollLeft);
      // console.log('###', Number(this.$refs.editTable[0].bodyWidth.replace('px', '')));
      const scrollLeft = this.$refs.editTable[0].bodyWrapper.scrollLeft;
      if (scrollLeft > 0) {
        this.$refs.editTable[0].bodyWrapper.scrollLeft = scrollLeft - 200 > 0 ? scrollLeft - 200 : 0;
      }
    },
    rightEvent() {
      let scrollLeft = this.$refs.editTable[0].bodyWrapper.scrollLeft;
      if (scrollLeft < this.maxScrollLeft) {
        this.$refs.editTable[0].bodyWrapper.scrollLeft = scrollLeft + 200 > this.maxScrollLeft ? this.maxScrollLeft : scrollLeft = scrollLeft + 200;
      }
    },
    setDisableArr(dArr) {
      // this.disableArr.push(dArr[0])
      if (dArr && dArr.length > 0) {
        this.disableArr = dArr.map(u => u);
      } else {
        this.disableArr = [];
      }
    },
    evil(fn) {
      // 一个变量指向Function，防止有些前端编译工具报错
      const Fn = Function;
      return new Fn('return ' + fn)();
    },
    getSummaries(param, tablemodel) { // tablemodel 当前子表单名称 ; param 当前子表单内的列字段{columns列属性;data列值}
      const T = this.tableTotalArray.find(m => m.tablemodel === tablemodel); // 从整个表单列表中 找出当前子表单合计字段的数据
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => { // 如果是第一列 就是合计
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (T.colmodel.includes(column.property)) { // 其他列如果带合计 合计属性 就算出 合计值
          let S = 0;
          this.models[tablemodel].forEach(item => {
            S += item[column.property];
          });
          sums[index] = S;
        } else { // 其他列 空字符串代替
          sums[index] = '';
        }
      });
      return sums;
    },
    changeDateFun(Tempobj) {
      var reg = /^[0-9]+|\+|-|\*|\/|\(|\)$/; // 正则表达式计算 匹配计算器上的固定按钮
      this.fuMalkeyArray.forEach(element => { // 遍历所有计算公式
        if (element.fuMalkey.includes(Tempobj.modelkey)) { // 若计算公式中包含 当前点击字段
          const tempfuMalkey = [];
          element.fuMalkey.forEach(item => { // 将该计算公式 拼接成可执行字符串
            if (item === Tempobj.modelkey) { // 点击字段在触发点击时 Tempobj.models内的值还是点击前的值，所以要单独判断
              tempfuMalkey.push(Tempobj.val);
            } else if (reg.test(item)) { // 如果为 常量(数字+-*.).则直接放入公式
              tempfuMalkey.push(item);
            } else { // 如果为字段名,则根据字段名取值放入公式
              tempfuMalkey.push(Tempobj.models[item]);
            }
          });
          Tempobj.models[element.key] = this.evil(tempfuMalkey.join('')); // 计算公式并赋值
        }
      });
    },
    AssignmentModel(key, value) {
      if (key) {
        this.$set(this.models, key, value);
      }
    },
    GetModelData(key) {
      const keyArray = Object.keys(this.models);
      if (key && keyArray.includes(key)) {
        return this.models[key];
      } else {
        return this.models;
      }
    },
    getTableRow(tableObj, valData) {
      const tempmodel = {};
      const itemKey = tableObj.list.map(m => {
        return m.model;
      });// 获取子表单每一行对象的所有字段属性
      const modelsKey = Object.keys(this.models);// 获取当前主表中的所有字段属性
      let returnArray = [];// 要返回的数组

      if (valData && Object.keys(valData).indexOf(tableObj.model) >= 0) { // 修改 赋值处理
        returnArray = valData[tableObj.model].map(m => ({ ...m }));// 将原来的数据全部获取
        tableObj.list.forEach(listitem => { // 获取所有子元素
          if (listitem.type === 'autoNew') { // 如果是选择关联组件
            listitem.options.otherquery.forEach(m => { // 组件中的查询条件数组
              returnArray.forEach(tempItem => { // 给子表单数据添加所需要的查询条件的值
                if (!itemKey.includes(m.modelkey) && modelsKey.includes(m.modelkey)) { // 若不存在于子表单则去主表单里找到并添加进来，若在子表单中就有则无需处理
                  this.$set(tempItem, m.modelkey, valData[m.modelkey]);// 赋值
                }
              });
            });
          }
        });
      } else if (modelsKey.includes(tableObj.model)) { // 添加 根据配置条件，添加一个空对象
        returnArray = this.models[tableObj.model] ? this.models[tableObj.model].map(m => ({ ...m })) : [];// 获取原来的数据,若原来，没数据则为空数组
        tableObj.list.forEach(listitem => { // 获取所有子元素
          if (listitem.type === 'autoNew') { // 如果是选择关联组件
            listitem.options.otherquery.forEach(m => { // 组件中的查询条件数组
              if (!itemKey.includes(m.modelkey) && modelsKey.includes(m.modelkey)) { // 若不存在于子表单则去主表单里找到并添加进来，若在子表单中就有则无需处理
                this.$set(tempmodel, m.modelkey, this.models[m.modelkey]);// 赋值，由于是添加，所以value中没有值，所以添加models中的值
              }
            });
          }
          this.$set(tempmodel, listitem.model, listitem.options.defaultValue);// 添加其他属性字段
        });
        returnArray.push(tempmodel);
      } else { // 初始化
        returnArray = tableObj.options.defaultValue;
      }
      return returnArray;
    },
    // table添加一行
    addSubitem(item) { // table的所有数据
      const temparray = this.getTableRow(item, {});// 添加则使用空对象
      this.$set(this.models, item.model, temparray);// 此处必须这样赋值，否则会清空数据
    },
    // table删除一行
    removeSubitem(item, model) { // 选中行，table的属性名
      var index = this.models[model].indexOf(item);
      if (index !== -1) {
        const temparray = this.models[model].map(m => ({ ...m }));
        temparray.splice(index, 1);
        this.$set(this.models, model, temparray);
        if (this.tableDeleteFun && typeof (this.tableDeleteFun) === 'function') {
          this.tableDeleteFun(this.models, temparray);
        }
      }
    },
    // 初始化models赋值和获取校验规则
    generateModle(arr) {
      arr.length > 0 && arr.forEach(arrItem => {
        if (arrItem.type === 'grid') { // 如果是栅格布局则进入递归
          arrItem.columns.forEach(item => {
            this.generateModle(item.list);
          });
        } else if (arrItem.type === 'table') {
          this.restTabel.push(arrItem);// 重新打开页面时 将重置其中的数据
          this.$set(this.models, arrItem.model, arrItem.options.defaultValue);// 这样添加数据才能监听到
          if (arrItem.type === 'number') {
            // console.log(arrItem)
            // this.fuMalkeyArray.push(arrItem.options.fuMalkey)
          }
          const tempModelCol = { tablemodel: arrItem.model, colmodel: [] }; // 声明一个对象接受字表名和列名
          arrItem.list.forEach(tableitem => {
            if (tableitem.type === 'number' && tableitem.options.fuMalkey && tableitem.options.fuMalkey.length > 0) {
              // console.log(arrItem)
              this.fuMalkeyArray.push({ key: tableitem.model, fuMalkey: tableitem.options.fuMalkey.map(m => m.key) });
            }
            if (tableitem.type === 'number' && tableitem.options.isTotal) { // 若类型是计数器且“合计”开关为开
              tempModelCol.colmodel.push(tableitem.model); // 将“合计”为开的列的的列名push进对象
            }
          });
          if (tempModelCol.colmodel.length > 0) { // 判断列此列是否有值
            this.tableTotalArray.push(tempModelCol); // 若有值，push给此数组
          }
          // console.log(arrItem.list)
          // 获取子表单校验规则
          arrItem.list.length > 0 && arrItem.list.forEach(subarrItem => {
            this.getRules(this.lstDtlrules, subarrItem);
          });
        } else {
          if (arrItem.type === 'blank') {
            this.$set(this.models, arrItem.model, arrItem.options.defaultType === 'String' ? '' : (arrItem.options.defaultType === 'Object' ? {} : []));
          } else {
            this.$set(this.models, arrItem.model, arrItem.options.defaultValue);
          }
          if (arrItem.type === 'number' && arrItem.options.fuMalkey && arrItem.options.fuMalkey.length > 0) {
            // console.log(arrItem.options.fuMalkey)

            this.fuMalkeyArray.push({ key: arrItem.model, fuMalkey: arrItem.options.fuMalkey.map(m => m.key) });
          }
          // 获取主表校验规则
          this.getRules(this.rules, arrItem);
        }
      });
    },
    getRules(rules, arrItem) {
      if (rules[arrItem.model]) {
        rules[arrItem.model] = [...rules[arrItem.model], ...arrItem.rules.map(item => {
          if (item.pattern) {
            return { ...item, pattern: JSON.stringify(item.pattern) };
          } else {
            return { ...item };
          }
        })];
      } else {
        rules[arrItem.model] = [...arrItem.rules.map(item => {
          if (item.pattern) {
            return { ...item, pattern: JSON.stringify(item.pattern) };
          } else {
            return { ...item };
          }
        })];
      }
    },
    getData() {
      return new Promise((resolve, reject) => {
        this.$refs.generateForm.validate(valid => {
          if (valid) {
            // console.log(JSON.stringify(this.models))
            resolve(this.models);
          } else {
            // 针对处理rules:[]，报错
            if (typeof (this.$t) === 'function') {
              reject(new Error(this.$t('fm.message.validError')).message);
            }
          }
        });
      });
    },
    reset() { // 重置数据
      this.$refs['generateForm'].resetFields();
      if (this.restTabel.length > 0) {
        this.restTabel.forEach(item => {
          this.$set(this.models, item.model, item.options.defaultValue);
        });
      }
    },
    clearValidate() { // 清空校验状态
      this.$refs['generateForm'].clearValidate();
    }
  },
  watch: { // 数据监听
    data: { // 外部传入的表单结构
      deep: true, // 深度监听，如果监听的是对象则一直循环监听，每一个字段改变都能监听到
      handler(val) {
        this.generateModle(val.list);
        Object.keys(this.value).forEach(item => {
          this.$set(this.models, item, this.value[item]);
        });
      }
    },
    models: {
      deep: true,
      handler(val) { // 监听models，用于当子表单中的组件需要主表的数据时，及时更新查询所用数据
        const tempArray = this.data.list.filter(item => {
          return item.type === 'table';
        });// 筛选子表数据
        tempArray.length > 0 && tempArray.forEach(item => { // 遍历子表数据
          const itemKey = item.list.map(m => {
            return m.model;
          });// 获取子表单每一行对象的所有属性
          const modelsKey = Object.keys(val);// 获取当前主表中的所有字段属性
          item.list.filter(listItem => {
            return listItem.type === 'autoNew';
          }).forEach(listItem => { // 筛选选择关联组件并遍历
            listItem.options.otherquery.forEach(m => { // 遍历查询条件
              this.models[item.model].forEach(tempItem => {
                if (!itemKey.includes(m.modelkey) && modelsKey.includes(m.modelkey)) { // 若不存在于子表单则去主表单里找到并添加进来，若在子表单中就有则无需处理
                  this.$set(tempItem, m.modelkey, val[m.modelkey]);
                }
              });
            });
          });
        });
      }
    }
  }
};
</script>

<style lang="scss">
.created-form-content {
  position: relative;

  .form-model {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  }
}

.dialog-mini .subtable .el-form-item {
  margin-bottom: 0px;
}

.dialog-mini .subtable .el-form-item.is-error.is-required.el-form-item--small {
  margin-bottom: 0px;
}

.warning .el-input.is-disabled .el-input__inner {
  color: red;
}

</style>

